import { moneyFormat } from '@/utils/utils'

export default function currencyFormat(money, currency = null) {
  return moneyFormat(money, currency)
}
